import React from 'react';
import useSelectedPack from './useSelectedPack';
import Label from '~/src/atoms/Label';
import tw from 'twin.macro';
import EtaVariants from './EtaVarient';


const ETA = ({ ...rest }) => {
  const { availability = {} } = useSelectedPack();
  if (availability?.avail_status === '001') {
    return (
      <Label css={tw`h-full`} {...rest}>
       <EtaVariants availability={availability} sa_id={rest?.sa_id} />
      </Label>
    );
  } else return <></>;
};

export default ETA;
